// extracted by mini-css-extract-plugin
export default {"container":"RatingBar2_container__jz5ZX","background":"RatingBar2_background__YnI9o","bar":"RatingBar2_bar__FSPxC"};